export function parseEmailListInput(value?: string | string[] | null): string[] {
  const values = (Array.isArray(value) ? value : [value || ''])
    .flatMap(item => item.split(/[,\n;]+/))
    .map(item => item.trim().toLowerCase())
    .filter(email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(email));
  return [...new Set(values)];
}

export function buildQuotationCcEmails(ccText: string, recipientEmail: string, autoCcEmails: string[] = []): string[] {
  const recipients = new Set(parseEmailListInput(recipientEmail));
  return parseEmailListInput([...autoCcEmails, ccText]).filter(email => !recipients.has(email));
}
